import { Component } from '@angular/core';

@Component({
  selector: 'subs-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'subs';
}
